import { twMerge } from 'tailwind-merge';

import { PostsViewerSection } from '../PostsViewerSection/PostsViewerSection';
import { RegistryWall } from './RegistryWall/RegistryWall';

interface RegisterWallViewProps {
  onBackButtonClick: () => void;
  userAvatarUrl: string;
  userNickname: string;
  className?: string;
}

export const RegisterWallView = ({
  className,
  onBackButtonClick: handleBackButtonClick,
  userAvatarUrl,
  userNickname,
}: RegisterWallViewProps) => {
  return (
    <PostsViewerSection
      className={twMerge(className)}
      navigationLocationName=" "
      onBackButtonClick={handleBackButtonClick}
    >
      <RegistryWall userAvatarUrl={userAvatarUrl} userNickname={userNickname} />
    </PostsViewerSection>
  );
};
